<template>
  <div class="dsf-add-exam">
    <div class="add-header">
      <span class="add-item add-btn">+ 新增试卷</span>
      <el-form label-width="100px" :rules="rules" :model="exam" ref="examForm">
        <el-form-item label="试卷分类" class="add-item">
          {{ exam.types.text }}
        </el-form-item>
        <el-form-item label="试卷名称" class="add-item add-exam-name" prop="name">
          <el-input v-model="exam.name"></el-input>
        </el-form-item>
      </el-form>
      <span class="add-item last">
        试卷总分
        <span class="total">{{ totalScore }}</span>
        分
        <span class="tip">(自动计算)</span>
      </span>
      <DsfButton class="save-btn" title="保存" @click="savePaper" :disabled="disabled" icon="baocun"> 保存 </DsfButton>
    </div>
    <div class="questions-area">
      <div class="info-board">
        <DsfVirtualScroll>
          <div class="total">
            <p>
              总题数：
              <span class="test_total"> {{ totalNum }} </span>题
            </p>
            <p>
              当前总分：
              <span class="total_score"> {{ totalScore }} </span>分
            </p>
          </div>
          <div class="item group_simple" v-for="(item, index) in exam.items" :key="index" @click="moveTo(index)">
            <h3 class="test_tittle">{{ item.name }}</h3>
            <p class="left_p">
              共
              <span class="test_num">{{ getTotalNum(item) }}</span>
              题 ，共
              <span class="all_fraction">{{ item.totalScore }}</span>
              分
            </p>
            <p v-if="item.questionsItems.value === 'input' && item.scoreMethod" class="left_p">
              <el-radio-group v-model="item.scoreMethod.value" @change="changeInput(item)">
                <el-radio label="1">按题计分</el-radio>
                <el-radio label="2">按空计分</el-radio>
              </el-radio-group>
            </p>
            <!-- <p v-if="item.questionsItems.value === 'checkbox'" class="left_p">
              <el-radio-group v-model="item.scoreMethod.value">
                <el-radio label="1">按题计分</el-radio>
                <el-radio label="3" class="has-tip">
                  按选项计分
                  <span class="tip">少选得分，多选不得分</span>
                </el-radio>
              </el-radio-group>
            </p> -->
            <!-- <p v-if="item.questionsItems.value === 'group'" class="left_p">
              <el-radio-group v-model="item.scoreMethod.value">
                <el-radio label="4">按整题计分</el-radio>
                <el-radio label="1">按小题计分</el-radio>
              </el-radio-group>
            </p> -->
            <p v-if="item.scoreMethod.value === '1'" class="left_p" style="position: relative">
              每题分数
              <input type="text" class="score" v-model="item.score" @input="resetItemScore(item)" />
              分
              <span v-if="item.error" class="el-form-item__error">{{ item.message }}</span>
            </p>
            <p v-if="item.scoreMethod.value === '2'" class="left_p">
              每空分数
              <input type="text" class="score" v-model="item.optionsScore" @input="changeInput(item)" />
              分
            </p>
            <!-- <p v-if="item.scoreMethod.value === '3'" class="left_p">
              每项分数
              <input
                type="text"
                class="score"
                v-model="item.score"
                @input="changeInput(item)"
              />
              分
            </p> -->
            <p class="test_icon_a">
              <a class="content-icon" @click="deleteItem(index, exam.items, exam, $event)">
                <i class="iconfont icon-icon_del"></i>
              </a>
              <a class="content-icon" @click="move(-1, index, exam.items, $event)">
                <i class="iconfont icon-icon_up"></i>
              </a>
              <a class="content-icon" @click="move(1, index, exam.items, $event)">
                <i class="iconfont icon-icon_down"></i>
              </a>
            </p>
          </div>
        </DsfVirtualScroll>
      </div>

      <div ref="questionsBoard" class="questions-board">
        <DsfVirtualScroll>
          <div :ref="'question' + index" class="group_simple" v-for="(item, index) in exam.items" :key="index">
            <p class="paper-name">
              <el-input v-model="item.name" placeholder="请输入内容"></el-input>
              <span>{{ item.questionsItems.text }}</span>
              <span class="add-question" @click="create(item.questionsItems, item)">+ 添加试题</span>
            </p>
            <div class="questions">
              <template v-if="item.questions && item.questions.length > 0">
                <div class="question" v-for="(question, i) in item.questions" :key="i">
                  <div class="left">
                    <dsf-exam-item-box
                      :readOnly="previewStatus"
                      :previewStatus="previewStatus"
                      :key="question.examQuestionsId"
                      :subjects="question"
                      :exam-index="i"
                      :type="'practice'"
                      :hide-mark="true"
                    />
                  </div>
                  <div class="right">
                    <div class="btns">
                      <a class="content-icon">
                        <i class="iconfont icon-icon_del" @click="deleteItem(i, item.questions, item, $event)"></i>
                      </a>
                      <a class="content-icon iconfont">
                        <i class="iconfont icon-icon_up" @click="move(-1, i, item.questions, $event)"></i>
                      </a>
                      <a class="content-icon iconfont">
                        <i class="iconfont icon-icon_down" @click="move(1, i, item.questions, $event)"></i>
                      </a>
                    </div>
                    <div class="question-info">
                      <p v-if="item.questionsItems.value === 'input' && question.scoreMethod" class="left_p">
                        <el-radio-group v-model="question.scoreMethod.value" @change="resetQuestionScore(question, item, item)">
                          <el-radio label="1">按题计分</el-radio>
                          <el-radio label="2" class="has-tip">按空计分</el-radio>
                        </el-radio-group>
                      </p>
                      <!-- <p
                      v-if="item.questionsItems.value === 'checkbox'"
                      class="left_p"
                    >
                      <el-radio-group
                        v-model="question.scoreMethod.value"
                        @change="resetCheckboxScore(question, item)"
                      >
                        <el-radio label="1">按题计分</el-radio>
                        <el-radio label="3" class="has-tip">
                          按选项计分
                          <br />
                          <span class="tip">少选得分，多选不得分</span>
                        </el-radio>
                      </el-radio-group>
                    </p> -->
                      <span class="example-score m-score">
                        {{ item.questionsItems.value === "group" ? "总分数" : "分 数" }}
                        <input class="score" v-model="question.score" @input="resetQuestionScore(question, item, item)" />
                        分
                        <span v-if="question.error" class="el-form-item__error">{{ question.message }}</span>
                      </span>

                      <template v-if="item.questionsItems.value === 'group'">
                        <div v-for="(childValue, childKey) in question.children" class="left_p" :key="childValue.examQuestionsId">
                          {{ childKey + 1 }}题
                          <p v-if="childValue.items.value === 'input' && childValue.scoreMethod" class="left_p">
                            <el-radio-group v-model="childValue.scoreMethod.value">
                              <el-radio label="1">按题计分</el-radio>
                              <el-radio label="2" class="has-tip">按空计分</el-radio>
                            </el-radio-group>
                          </p>
                          <span class="example-score m-score">
                            分 数
                            <input class="score" v-model="childValue.score" @input="resetQuestionScore(childValue, question, item)" />
                            分
                            <span v-if="childValue.error" class="el-form-item__error">{{ childValue.message }}</span>
                          </span>

                          <div v-if="childValue.scoreMethod && childValue.scoreMethod.value == 2" class="muti-sel-score">
                            <div v-for="(option, oIndex) in childValue.options" :key="oIndex" class="example-score">
                              <span class="sel_style">第{{ oIndex + 1 }}空</span>
                              <input class="score" v-model="option.score" @input="resetQuestionOption(childValue, question, item)" />
                              分
                            </div>
                          </div>
                          <el-divider />
                        </div>
                      </template>
                      <div v-if="question.scoreMethod && question.scoreMethod.value == 2" class="muti-sel-score">
                        <div v-for="(option, oIndex) in question.options" :key="oIndex" class="example-score">
                          <span class="sel_style">第{{ oIndex + 1 }}空</span>
                          <input class="score" v-model="option.score" @input="resetQuestionOption(question, item)" />
                          分
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.settings && item.settings.length > 0">
                <div class="question" v-for="(setting, i) in item.settings" :key="i">
                  <div class="left">
                    <el-form ref="form" label-width="80px">
                      <el-form-item label="试题分类" class="tags">
                        <span v-if="setting.questionsTypes">
                          {{ setting.questionsTypes.text }}
                        </span>
                      </el-form-item>
                      <el-form-item label="试题标签" class="tags">
                        <span v-for="(Label, difIndex) in setting.tags" :key="difIndex" class="tag">
                          {{ Label }}
                        </span>
                      </el-form-item>
                      <el-form-item label="难易程度">
                        <p class="diff-item" v-for="(diff, difIndex) in setting.difficulties" :key="difIndex">
                          <span class="difficulty">
                            {{ diff.difficulty.text }}
                          </span>
                          <span class="diff-num">
                            {{ diff.questionsNum }}
                          </span>
                        </p>
                      </el-form-item>
                      <p>
                        <el-radio class="random" label="随机" value="随机"></el-radio>
                        <span class="tip">（每位学员试题不一致）</span>
                      </p>
                    </el-form>
                  </div>
                  <div class="right">
                    <div class="btns">
                      <a class="content-icon" @click="editItem(item, setting, $event)">
                        <i class="iconfont icon-edit"></i>
                      </a>
                      <a class="content-icon">
                        <i class="iconfont icon-icon_del" @click="deleteItem(i, item.settings, item, $event)"></i>
                      </a>
                      <a class="content-icon iconfont">
                        <i class="iconfont icon-icon_up" @click="move(-1, i, item.settings, $event)"></i>
                      </a>
                      <a class="content-icon iconfont">
                        <i class="iconfont icon-icon_down" @click="move(1, i, item.settings, $event)"></i>
                      </a>
                    </div>
                    <div class="question-info">
                      <span class="example-score m-score">
                        分 数
                        <input class="score" v-model="setting.score" @input="resetSettingScore(setting, item)" />
                        分
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <template>
                <div v-if="item.questions.length === 0 && item.settings.length === 0" class="empty">
                  此大题还未添加试题，请点击
                  <span class="add-question" @click="create(item.questionsItems, item)"> +添加试题 </span>
                  按钮选择试题
                </div>
              </template>
            </div>
          </div>
          <div class="ipt-questions-box">
            <div class="create_q_contain">
              <div class="create_q_group_icon">
                <span>+</span>
              </div>
              <br />
              <span class="create_q_group_text">创建新的大题</span>
            </div>
            <div class="create_q_contain question-btns">
              <button v-for="(type, index) in questionTypes" :key="index" type="button" class="q_type_btn" @click="create(type)">
                <span>{{ type.text }}</span>
              </button>
            </div>
          </div>
        </DsfVirtualScroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamAdd",
  provide() {
    return {
      exam: this,
    };
  },
  components: {},
  data() {
    return {
      disabled: false,
      exam: {
        examPaperId: this.$route.query.id,
        name: "试卷名称",
        types: {
          text: this.$route.query.typeText,
          value: this.$route.query.typeValue,
        },
        totalScore: 0,
        totalNum: 0,
        items: [],
      },
      questionTypes: [
        {
          text: "单选题",
          value: "radio",
        },
        {
          text: "多选题",
          value: "checkbox",
        },
        {
          text: "判断题",
          value: "judge",
        },
        {
          text: "填空题",
          value: "input",
        },
        {
          text: "主观题",
          value: "subjective",
        },
        {
          text: "组合题",
          value: "group",
        },
      ],
      rules: {
        name: [
          { required: true, message: "请输入试卷名称", trigger: "blur" },
          {
            min: 3,
            max: 100,
            message: "试卷名称长度在 3 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
      scoreMethod: {
        1: "按题记分",
        2: "按空计分",
        3: "按选项计分",
      },
      previewStatus: true,
    };
  },
  computed: {
    totalScore() {
      const totalScore = this.exam?.items.reduce((a, b) => {
        return a + Number(b.totalScore);
      }, 0);
      return totalScore;
    },
    totalNum() {
      const totalNum = this.exam?.items.reduce((a, b) => {
        return a + Number(this.getTotalNum(b));
      }, 0);
      return totalNum;
    },
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      if (this.$route?.query?.id) {
        this.$http
          .get(`/paper/getPaperDtailInfo/${this.$route.query.id}`, {}, $$webRoot.exam)
          .done(({ success, data, message }) => {
            if (success) {
              data.items.forEach((item) => {
                item.questions.forEach((question) => {
                  if (item?.questionsItems?.value === "input") {
                    if (item?.scoreMethod?.value === "1") {
                      const length = question.options?.length;
                      question.options?.forEach((option) => {
                        option.score = (question.score / length).toFixed(2);
                      });
                    }
                  }
                });
              });
              Object.assign(this.exam, data);
            } else {
              dsf.layer.message(message || "请求异常", false);
            }
          })
          .catch((error) => {});
      }
    },
    getTotalNum(item) {
      const settingLen = item.settings.reduce((a, b) => {
        const diffScore = b.difficulties.reduce((difA, difB) => {
          return difA + Number(difB.questionsNum);
        }, 0);
        return a + diffScore;
      }, 0);
      const quesLen = item.questions.length;
      return settingLen + quesLen;
    },
    editItem(item, setting, e) {
      const ids = this.exam.items
        .map((item) => {
          if (item?.questionsItems?.value === item.questionsItems.value) {
            return item.questions.map((qus) => qus.examQuestionsId);
          }
          return [];
        })
        .flat();
      const url = `exam/paper/items/setting/edit?items=${item.questionsItems.value}`;
      this.$openDialog({
        title: "修改随机试题规则",
        width: "1000px",
        height: "564px",
        overflow: "auto",
        dialogArgs: {
          setting: setting,
          ids: ids,
        },
        params: {
          path: url,
        },
        btns: [
          {
            text: "确定",
            handler: async (com) => {
              let options = {
                isSilent: true,
                isRefresh: false,
                savedClose: false,
                successMsg: "",
                errorMsg: "",
              };
              const form = com?.$refs?.view;
              const res = await form?.formSave(options);
              Object.assign(setting, res.data, {
                tags: res.data?.questionsLabels?.text?.split("^") ?? [],
                score: setting.score,
              });
              this.getItemScore(item);
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    deleteItem(index, items, parent, e) {
      e.stopPropagation();
      dsf.layer
        .confirm("确认删除吗？")
        .then(() => {
          items.splice(index, 1);
          parent.totalNum = items.length;
          this.getItemScore(parent);
        })
        .catch(() => {});
    },
    move(type, index, items, e) {
      e.stopPropagation();
      if (!items[index + type]) {
        return;
      }
      const next = index + type;
      const temp = items[index];
      this.$set(items, index, items[next]);
      this.$set(items, next, temp);
    },
    moveTo(index) {
      const top = this.$refs["question" + index][0].getBoundingClientRect().top;
      const scrollTop = document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTop;
      document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTo({
        top: top + scrollTop - 90,
        behavior: "smooth", // 平滑滚动
      });
    },
    create(type, item) {
      // console.log('type, item', type, item)
      if (item?.scoreMethod) {
        // item.scoreMethod.text = this.scoreMethod[item.scoreMethod.value];
        this.$set(item.scoreMethod, "text", this.scoreMethod[item.scoreMethod.value]);
      }
      const ids = this.exam.items
        .map((item) => {
          if (item?.questionsItems?.value === type.value) {
            return item.questions.map((qus) => qus.examQuestionsId);
          }
          return [];
        })
        .flat();
      const url = `exam/paper/items/selectQuestions?items=${type.value}`;
      this.$openDialog({
        title: "选择试题",
        width: "90%",
        height: "700px",
        overflow: "auto",
        dialogArgs: {
          ids: ids,
          item: item,
        },
        params: {
          path: url,
        },
        btns: [
          {
            text: "确定",
            handler: (com) => {
              return this.handlerResult(com, item, type);
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    async handlerResult(com, item, type) {
      const activeName = com?.$refs?.view?.$refs?.Tabs?.activeName;
      let data, questions, setting;
      if (activeName === "selectQues") {
        data = await com?.$refs?.view?.$refs?.Manually?.yes?.();
        if (data?.length === 0) {
          dsf.layer.message("请选择试题", false);
          return false;
        }
        const ids = data.map((item) => item._id);
        questions = await this.getSelectQuestions(ids);
        if (!questions) {
          return;
        }
        // 处理下组合题添加时 按题计分
        const questionsData = questions[0].items.value == "group" ? questions[0].children : questions;
        questionsData.forEach((question) => {
          question.error = false;
          question.message = "";
          question.score = item?.score ?? 0;
          if (!question.scoreMethod.text) {
            question.scoreMethod = {
              text: "按题计分",
              value: "1",
            };
          }
        });
      } else if (activeName === "autoQues") {
        let options = {
          isSilent: true,
          isRefresh: false,
          savedClose: false,
          successMsg: "",
          errorMsg: "",
        };
        const form = com?.$refs?.view?.$refs?.Automatically?.$refs?.view;
        var difficulty = form.$refs.difficulty.value;
        console.log(difficulty);
        var isZero = difficulty.every((ele) => ele["exam_paper_items_setting_difficulty.questions_num"] < 1);
        if (isZero) {
          dsf.layer.message("请填写试题数量", false);
          return false;
        } else {
          const res = await form?.formSave(options);
          if (Array.isArray(res.data)) {
            res.data.forEach((question) => {
              question.error = false;
              question.message = "";
              question.score = item?.score ?? 0;
            });
            questions = res.data;
          } else {
            if (!res.data?.isRandom) {
              dsf.layer.message("请填写正确的抽题规则", false);
              return false;
            }
            setting = Object.assign(res.data, {
              questionsItems: type,
              scoreMethod: item?.scoreMethod ?? null,
              tags: res.data?.questionsLabels?.text?.split("^") ?? [],
            });
          }
        }
      } else if (activeName === "improtQues") {
        //
      } else {
        data = await com.yes();
      }
      if (item) {
        if (questions) {
          item.questions.push(...questions);
        }
        if (setting) {
          item.settings.push(setting);
        }
        this.getItemScore(item);
        return true;
      }
      let newItem = {
        name: type.text,
        questionsItems: type,
        totalNum: questions?.length ?? 0,
        totalScore: 0,
        score: "",
        scoreMethod: {
          text: "按题计分",
          value: "1",
        },
        optionsScore: "",
        dsOrder: this.exam.items.length,
        questions: questions ? [...questions] : [],
        settings: setting ? [setting] : [],
        error: false,
        message: "",
      };
      this.exam.items.push(newItem);
      this.getItemScore(newItem);
      return true;
    },
    getSelectQuestions(ids) {
      return this.$http
        .get("/questions/getQuestionsByIds", { ids: ids }, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            return res.data;
          }
          dsf.layer.message(res.message, false);
          return false;
        })
        .catch((error) => {});
    },
    changeInput(item) {
      this.$set(item.scoreMethod, "text", this.scoreMethod[item.scoreMethod.value]);
      item?.questions?.forEach((question) => {
        question.scoreMethod.value = item.scoreMethod.value;
        this.$set(question.scoreMethod, "text", this.scoreMethod[item.scoreMethod.value]);
        if (!item.score && !item.optionsScore) {
          return;
        }
        if (item.scoreMethod.value === "1") {
          // 按题得分
          const length = question.options.length;
          question.options.forEach((option) => {
            option.score = (question.score / length).toFixed(2);
          });
          question.score = item.score;
        } else {
          // 按空得分
          const length = question.options.length;
          question.options.forEach((option) => {
            option.score = item.optionsScore;
          });
          question.score = item.optionsScore * length;
        }
      });
      item?.settings?.forEach((setting) => {
        setting.score = item.score;
      });

      this.getItemScore(item);
    },
    resetItemScore(item) {
      if (this.regScore(item)) {
        item.questions.forEach((question) => {
          question.score = item.score;
          // 如果右侧为按空 计算子级分
          if (question.scoreMethod.value == 2) {
            const length = question.options.length;
            question.options.forEach((option) => {
              option.score = (question.score / length).toFixed(2);
            });
          }
        });
        const questionsScore = this.countQuestionsScore(item);
        item.settings?.forEach((setting) => {
          setting.score = item.score;
        });
        const settingScore = this.countSettingScore(item);
        item.totalScore = questionsScore + settingScore;
        item.totalNum = this.getTotalNum(item);
        if (item.questionsItems.value == "group") {
          this.countGroup(item);
        }
      }
    },
    resetQuestionScore(question, item, groupItem) {
      // console.log("question, item", question, item, groupItem);
      if (this.regScore(question)) {
        item.score = "";
        this.getItemScore(item, groupItem);
        if (question.scoreMethod.value == 2) {
          const length = question.options.length;
          question.options.forEach((option) => {
            option.score = (question.score / length).toFixed(2);
          });
        }

        // 组合题平均分
        if (question?.children) {
          const childLength = question.children.length;
          question.children.forEach((option) => {
            option.score = (question.score / childLength).toFixed(2);
          });
        }
      }
    },
    resetQuestionOption(question, item, groupItem) {
      // console.log("填空分", question, item, groupItem);
      item.score = "";
      item.optionsScore = "";
      this.getQuesScoreByOption(question);
      this.getItemScore(item, groupItem);
    },
    resetSettingScore(setting, item) {
      item.score = "";
      this.getItemScore(item);
    },
    regScore(item) {
      let reg = /^\d+(\.\d+)?$/;
      // 有分 并用为正数
      if (item.score && reg.test(item.score)) {
        item.error = false;
        return true;
      } else {
        item.error = true;
        item.message = "请输入正数";
        return false;
      }
    },

    // 多选题
    // resetCheckboxScore(question, item) {
    //   item.score = "";
    //   this.getItemScore(item);
    // },
    getItemScore(item, groupItem) {
      const questionsScore = this.countQuestionsScore(item);
      // 组合题计算
      if (item?.questionsItems?.value == "group" || item?.items?.value == "group" || item?.children) {
        // 当前大题总分数
        // console.log("questionsScore", questionsScore, item);
        if (item?.questionsItems?.value == "group") {
          // 计算子题分
          item.score = questionsScore;
          // 删除时 计算
          if (!groupItem) {
            item.score = "";
            item.totalScore = questionsScore;
          }
        } else {
          // 子题操作
          item.score = questionsScore;
        }
        // 左侧组合题分 添加试题没有
        if (groupItem) {
          groupItem.totalScore = _.sumBy(groupItem.questions, (item) => Number(item.score));
          groupItem.totalNum = groupItem.questions.length;
          groupItem.score = "";
        }
      } else {
        const settingScore = this.countSettingScore(item);
        item.totalScore = questionsScore + settingScore;
        item.totalNum = this.getTotalNum(item);
      }
    },
    countGroup(item) {
      // 每题得分
      let score = (item.totalScore / item.totalNum).toFixed(2);
      _.forEach(item.questions, (option) => {
        let childScore = option.children.length;
        _.forEach(option.children, (item) => {
          item.score = (score / childScore).toFixed(2);
        });
      });
    },
    countQuestionsScore(item) {
      // 组合题、其它大题
      let questionsItem = item.questions || item.children;
      return questionsItem.reduce((a, b) => {
        if (b.items.value === "checkbox" && b.scoreMethod.value == 3) {
          const length = b.options.filter((option) => option.isRight.value === "1").length;
          return a + Number(b.score) * length;
        }
        return a + Number(b.score);
      }, 0);
    },
    countSettingScore(item) {
      return item.settings.reduce((a, b) => {
        const diffScore = b.difficulties.reduce((difA, difB) => {
          return difA + Number(difB.questionsNum) * Number(b.score);
        }, 0);
        return a + diffScore;
      }, 0);
    },
    getQuesScoreByOption(question) {
      question.score = question.options.reduce((a, b) => {
        return a + Number(b.score);
      }, 0);
    },
    savePaper() {
      this.$refs.examForm.validate((valid) => {
        if (valid) {
          this.save();
        }
        // else {
        //   // dsf.layer.message(`试卷名称不能为空`, false);
        // }
      });
    },
    save() {
      if (this.disabled) {
        return;
      }
      if (this.exam?.items?.length === 0) {
        dsf.layer.message("请选择试题", false);
        return;
      }
      this.exam.totalNum = this.totalNum;
      this.exam.totalScore = this.totalScore;
      // 每题分数必填
      let score = [];
      // 每大题必需要有题
      let examItem = [];
      // 当前有错题提示
      let over = false;
      // 增加排序
      this.exam.items.forEach((item, index) => {
        if (item.error) {
          over = true;
        }
        item.dsOrder = index + 1;
        if (!item.questions.length && !item.settings.length) {
          examItem.push(item);
        }
        item.questions.forEach((question, quesIndex) => {
          if (question.error) {
            over = true;
          }
          // 有组合题时
          if (question?.children?.length) {
            _.forEach(question.children, (child) => {
              if (child.error) {
                over = true;
              }
            });
          }
          question.dsOrder = quesIndex + 1;
          score.push(Number(question.score));
        });
        item.settings.forEach((question, quesIndex) => {
          if (question.error) {
            over = true;
          }
          // question.dsOrder = quesIndex + 1;
          score.push(Number(question.score));
        });
      });
      if (over) {
        dsf.layer.message("分数验证失败,不能提交", false);
        return;
      }
      if (examItem.length) {
        this.moveTo(examItem[0].dsOrder - 1);
        dsf.layer.message(examItem[0].name + "试题不能为空", false);
        return;
      }
      if (!_.every(score, Boolean)) {
        dsf.layer.message("试题分数为必填且不能为0", false);
        return;
      }
      this.disabled = true;
      this.$http
        .post(
          "/paper/updatePaper",
          JSON.stringify(this.exam),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done((res) => {
          this.disabled = false;
          if (res.success) {
            dsf.layer.message(`${this.$route.query.id ? "修改" : "保存"}成功`);
            this.exam.examPaperId = res.data;
            let params = dsf.mix({}, this.$route.query, {
              id: res.data,
            });
            //更新url添加id参数
            this.$router.replace({
              path: this.$route.path,
              query: params,
            });
            // 刷新父级
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$openerVm = window.opener.openerVms[window.name] || null;
              this.$openerVm?.reloadData();
            }
          } else {
            dsf.layer.message(`${this.$route.query.id ? "修改" : "保存"}失败`, false);
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
